import { lazy } from 'react';
import { fulfillmentOrderPermissions } from '../views/Main/Inventory/FulfillmentOrders/FulfillmentOrders';
import { orderPermissions } from '../views/Main/Inventory/Orders/Order';
import { RouteType } from './Router';

const FulfillmentOrderLogs = lazy(
  () => import('../views/Main/Inventory/FulfillmentOrders/FulfillmentOrderLogs/FulfillmentOrderLogs')
);
const OrderLogs = lazy(() => import('../views/Main/Inventory/Orders/OrderLogs/OrderLogs'));

export const InventoryRoutes: RouteType[] = [
  {
    path: '/inventory/fulfillment-orders/:id/logs',
    name: 'Fulfillment Order Logs',
    component: FulfillmentOrderLogs,
    exact: true,
    allowedPermissionRoles: fulfillmentOrderPermissions.READ,
  },
  {
    path: '/inventory/orders/:id/logs',
    name: 'Order Logs',
    component: OrderLogs,
    exact: true,
    allowedPermissionRoles: orderPermissions.READ,
  },
];

export default InventoryRoutes;
